
import CoreFormElementInputBase from './BaseInput';
import { CoreFormElementProps } from '../../interfaces/';
import { FORM_ELEMENT_PROPS, INPUT_TYPE_URL } from '../../constants/';
import { HashMapMergeProps } from '../../../../../utils/';

/**
 * Url Input Element
 * @export
 * @class CoreFormElementUrl
 * @extends {CoreFormElementInputBase}
 */
export default class CoreFormElementUrl extends CoreFormElementInputBase {
  /**
   * Default Props
   * @static
   * @type {Omit<CoreFormElementProps, 'name'>}
   * @memberof CoreFormElementUrl
   */
  public static defaultProps: Omit<CoreFormElementProps, 'name'> = HashMapMergeProps(FORM_ELEMENT_PROPS, {
    type: INPUT_TYPE_URL,
    placeholder: 'http[s]://...'
  });
}
